/**
 * Application Catalogue Services
 * Services for the CCMS mobile constellation app catalogue.
 */
// Export service classes
export { ApplicationCatalogueService } from './ApplicationCatalogueService';
export { AppDistributionService } from './AppDistributionService';
// Import for factory function
import { ApplicationCatalogueService } from './ApplicationCatalogueService';
import { AppDistributionService } from './AppDistributionService';
/**
 * Create all application catalogue services.
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all application catalogue services
 */
export function createApplicationCatalogueServices(http, config) {
    return {
        catalogue: new ApplicationCatalogueService(http, config),
        distribution: new AppDistributionService(http, config),
    };
}
//# sourceMappingURL=index.js.map